export const i9Link =
  'https://www.uscis.gov/sites/default/files/document/forms/i-9-paper-version.pdf';
export const w4Link = 'https://www.irs.gov/pub/irs-pdf/fw4.pdf';
export const jobCategoryHelpLink =
  'https://www.eeoc.gov/employers/eeo-1-survey/eeo-1-job-classification-guide-2010';
